import { render, staticRenderFns } from "./VehicleProfile.vue?vue&type=template&id=5add48f6"
import script from "./VehicleProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleProfile.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VehicleProfile.vue?vue&type=style&index=0&id=5add48f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QSeparator,QBtn,QField});
